var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1465,
    height: 33,
    viewBox: "0 0 1465 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1465,
    height: 32,
    fill: "url(#paint0_linear_57_19)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 1465,
    height: 2.5,
    fill: "#DFE3E3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 1465,
    height: 2.5,
    fill: "#DFE3E3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 16.5,
    width: 1465,
    height: 2.5,
    fill: "#DFE3E3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 1465,
    height: 2.5,
    fill: "#DFE3E3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 1465,
    height: 2.5,
    fill: "#DFE3E3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 1465,
    height: 2.5,
    fill: "#DFE3E3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1465,
    height: 2.5,
    fill: "#DFE3E3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 30.5,
    width: 1465,
    height: 2,
    fill: "#DFE3E3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_19",
    x1: 607.544,
    y1: -3.55556,
    x2: 607.544,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.591346,
    stopColor: "#FCFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.1a4e4b80449ee9701fd2985c5e6e8630.svg";
export { ForwardRef as ReactComponent };